'use client';

import React, { useState, useEffect } from 'react';
import { MdDarkMode, MdLightMode } from 'react-icons/md';

import styles from './ThemeToggle.module.css';

const ThemeToggle: React.FC = () => {
  const [ theme, setTheme ] = useState<'light' | 'dark'>('light');

  useEffect(() => {
    // Load theme from localStorage
    const savedTheme = (localStorage.getItem('chakra-ui-color-mode') || localStorage.getItem('theme')) as 'light' | 'dark' | null;
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      // Check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const initialTheme = prefersDark ? 'dark' : 'light';
      setTheme(initialTheme);
      document.documentElement.setAttribute('data-theme', initialTheme);
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('chakra-ui-color-mode', newTheme);
  };

  return (
    <button
      className={ styles.toggleButton }
      onClick={ toggleTheme }
      aria-label="Toggle theme"
      title={ `Switch to ${ theme === 'light' ? 'dark' : 'light' } theme` }
    >
      { theme === 'light' ? (
        <MdDarkMode size={ 20 }/>
      ) : (
        <MdLightMode size={ 20 }/>
      ) }
    </button>
  );
};

export default ThemeToggle;
